import { render, staticRenderFns } from "./GoalCategoryConfigModal.vue?vue&type=template&id=fad4eea6&"
import script from "./GoalCategoryConfigModal.vue?vue&type=script&lang=js&"
export * from "./GoalCategoryConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./GoalCategoryConfigModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports